import React, { useState, useEffect } from "react";
import Modal from "components/modal";
import { useGlobalContext } from "context/global";

const ConfirmDialog = ({ isOpen, setIsOpen, title, description, confirmText, callback, className }) => {
	const [loading, setLoading] = useState(false);
	const { translation } = useGlobalContext();

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Enter" && callback && isOpen) {
				confirmChoice();
			} else if (event.key === "Escape" && isOpen) {
				setIsOpen(false);
			}
		};

		document.addEventListener("keydown", handleKeyDown);

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [callback, isOpen]);

	const confirmChoice = async () => {
		if (loading) return;
		if (callback) {
			setLoading(true);
			await callback();
			setLoading(false);
			setIsOpen(false);
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			close={() => setIsOpen(false)}
			className={className ?? "max-w-[450px]"}
			overlayClassName="max-w-none"
			hideHeader={true}
		>
			<div className="p-10 flex flex-col gap-3 items-center text-center">
				<div className="mb-4 flex flex-col gap-3">
					{title && <h3>{title}</h3>}
					{description && <p className="text-base text-secondary">{description}</p>}
				</div>
				{confirmText && (
					<button disabled={loading} className="btn-primary w-full uppercase text-sm !px-0" onClick={confirmChoice}>
						{loading ? `${translation?.other.loading}...` : confirmText}
					</button>
				)}
				<button onClick={() => setIsOpen(false)} className="btn-tertiary">
					{translation.other?.cancel ?? "Cancel"}
				</button>
			</div>
		</Modal>
	);
};

export default ConfirmDialog;
